var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"width":420,"clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}],null,true),model:{value:(_vm.showMenuComponent),callback:function ($$v) {_vm.showMenuComponent=$$v},expression:"showMenuComponent"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }